import { render } from "./DashboardContent.vue?vue&type=template&id=e2dc7d9a&scoped=true"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"

import "./DashboardContent.vue?vue&type=style&index=0&id=e2dc7d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2dc7d9a"]])

export default __exports__